/**
 * Utility functions for Reports module
 */

import { CHART_COLORS } from './constants';

export interface MockBarData {
  name: string;
  value: number;
  target: number;
}

export interface MockPieData {
  name: string;
  value: number;
  color: string;
  [key: string]: string | number;
}

export interface MockKPIData {
  value: number;
  target: number;
  trend: string;
  change: string;
}

// Mock data generator for demo purposes
export function generateMockData(chartType: string): MockBarData[] | MockPieData[] | MockKPIData {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];
  const categories = ['Category A', 'Category B', 'Category C', 'Category D', 'Category E'];

  switch (chartType) {
    case 'bar':
    case 'line':
    case 'waterfall':
      return months.map((month) => ({
        name: month,
        value: Math.floor(Math.random() * 1000) + 100,
        target: Math.floor(Math.random() * 800) + 200,
      }));
    case 'pie':
    case 'donut':
      return categories.map((cat, index) => ({
        name: cat,
        value: Math.floor(Math.random() * 500) + 100,
        color: CHART_COLORS[index % CHART_COLORS.length],
      }));
    case 'kpi':
      return {
        value: Math.floor(Math.random() * 100),
        target: 80,
        trend: Math.random() > 0.5 ? 'up' : 'down',
        change: (Math.random() * 20 - 10).toFixed(1),
      };
    default:
      return months.map((month) => ({
        name: month,
        value: Math.floor(Math.random() * 1000) + 100,
        target: 0,
      }));
  }
}
